// components/rating/index

import Inputs from "../inputs";


function Rating() {
    var object = {
            el: document.querySelector(".rating"),
            rating: "",
            ratingField: "",
            form: "",
            close: "",
        },
        i = 0;

    if (object.el === null || object.el.nodeType !== 1) {
        return false;
    }

    var inputs = new Inputs();

    object.rating = object.el.getAttribute("data-rating");
    object.stars = object.el.querySelectorAll(".rating__star");
    object.form = object.el.querySelector(".rating__form");
    object.ratingField = object.form.querySelector("#input_1_5");
    object.close = object.form.querySelector(".rating__close");

    for (i = 0; i < object.rating; i++) {
        object.stars[i].classList.add("is-rated");
    }

    for (i = 0; i < object.stars.length; i++) {
        object.stars[i].addEventListener("click", this.clickHandler.bind(object.stars[i], object));
    }

    object.close.addEventListener("click", function () {
        object.form.classList.remove("is-visible");
    });
}

Rating.prototype.clickHandler = function (object) {
    var value = this.getAttribute("data-value"),
        i = 0;

    object.setRating = value;
    object.ratingField.value = object.setRating;

    object.form.classList.add("is-visible");

    for (i = 0; i < object.stars.length; i++) {
        object.stars[i].classList.remove("is-rated");
    }

    for (i = 0; i < value; i++) {
        object.stars[i].classList.add("is-rated");
    }
};

export default Rating;



// WEBPACK FOOTER //
// ./js/components/rating/index.js